import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	MovementPagePetitionsInMovementQuery,
	MovementPagePetitionsInMovementQueryVariables,
} from './getPetitionsInMovement.graphql';
import { MovementPagePetitionsInMovement } from './getPetitionsInMovement.graphql';

export async function getPetitionsInMovement(
	movementId: string,
	limit: number,
	offset: number,
	{ gql: { fetch } }: UtilityContext,
): Promise<NonNullable<MovementPagePetitionsInMovementQuery['petitionsInMovement']>> {
	const { data } = await fetch<MovementPagePetitionsInMovementQuery, MovementPagePetitionsInMovementQueryVariables>({
		query: MovementPagePetitionsInMovement,
		variables: { id: movementId, limit, offset },
		rejectOnError: true,
	});

	if (!data.petitionsInMovement) {
		throw new Error('Error retrieving petitions in the movement');
	}
	return data.petitionsInMovement;
}
